/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';
import { postRequest, putRequest } from 'src/utils/RequestUtil';

// API call to search wallet payments
export const walletPaymentSearchAPI = function (data) {
    const url = `${config.baseUrl}wallet-payment/search`;
    return postRequest({
        url,
        data,
    });
};

// API call to create a new wallet payment
export const walletPaymentCreateAPI = function ({ data }) {
    const url = `${config.baseUrl}wallet-payment`;
    return postRequest({
        url,
        data,
    });
};

// API call to update an existing wallet payment
export const walletPaymentUpdateAPI = function ({ walletId, data }) { 
    const url = `${config.baseUrl}wallet-payment/${walletId}`;
    return putRequest({
        url,
        data,
    });
};

// API call to bulk update wallet payment transactions
export const walletPaymentBulkUpdateTransactionsAPI = function (data) {
    const url = `${config.baseUrl}wallet-payment/bulk-update-transactions`;
    return putRequest({
        url,
        data,
    });
};
